/**
 * EasyEvent client-side entry point for the Marketing site.
 * Used by: EasyEvent.Web.Marketing
 *
 * Contains only the phone-preview component, used to embed a live
 * TenantClient preview (PawsCon demo) on the marketing landing page.
 */

import { PhonePreviewElement } from "./components/phone-preview";

// Register custom elements
customElements.define("ee-phone-preview", PhonePreviewElement);

console.log("[EasyEvent] Marketing web components registered.");
